<template>
  <v-card outlined>
    <v-card-title>
      {{ $t("auditor.internalCommentForm.title") }}
    </v-card-title>

    <v-card-text v-if="focus || !requirement.internalComment || !requirement.internalComment.length">
      <v-form ref="form">
        <MarkdownEditor
          :label="$t('auditor.internalCommentForm.label')"
          :autofocus="focus"
          v-model="formData.internalComment"
          @change="save"
          @blur="focus = false"
        />
      </v-form>
    </v-card-text>

    <v-card-text v-else @click="focus = true">
      <Markdown :value="formData.internalComment"></Markdown>
    </v-card-text>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-card>
</template>

<script>
import { pick } from "ramda";
import UpdateMinimalRequirementMutation from "@/gql/mutations/UpdateMinimalRequirementMutation.gql";
import UpdateStepModelRequirementMutation from "@/gql/mutations/UpdateStepModelRequirementMutation.gql";
import MarkdownEditor from "@/components/Common/MarkdownEditor.vue";

export default {
  components: {
    MarkdownEditor,
  },

  props: {
    model: {
      type: String,
      default: "minimal",
    },

    requirement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: null,
      valid: false,
      loading: false,
      saved: false,
      focus: false,
    };
  },

  computed: {
    mutation() {
      return this.model === "minimal" ? UpdateMinimalRequirementMutation : UpdateStepModelRequirementMutation;
    },
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      await this.$apollo.mutate({
        mutation: this.mutation,
        variables: {
          id: this.requirement.id,
          input: this.formData,
        },
      });

      this.loading = false;
      this.saved = true;
      this.$emit("save");
    },
  },

  watch: {
    // update form data if data is unchanged
    // that way the form is updated if the data has not been altered/worked on
    // if the data has been changed, it will not be updated
    requirement(requirement, oldRequirement) {
      if (oldRequirement.internalComment === this.formData.internalComment)
        this.formData.internalComment = requirement.internalComment;
    },
  },

  created() {
    this.formData = pick(["internalComment"], this.requirement);
  },
};
</script>
